
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thank-you-for-participating-in-survey",
      function () {
        return require("private-next-pages/thank-you-for-participating-in-survey.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/thank-you-for-participating-in-survey"])
      });
    }
  